import { useActions } from 'shared/hooks';
import { getContent, postFeedback } from 'store/survey/actions';
import { SendFeedbackInformationData } from '../../../../api/surveys/types';

export const useSurveyActions = () =>
  useActions({
    postFeedback,
    getContent,
  });

export const useHandleSubmit = () => {
  const { postFeedback: postAction } = useSurveyActions();
  return (data: SendFeedbackInformationData) => {
    postAction(data);
  };
};
